<div *ngIf="tileViewDataSource == undefined || tileViewDataSource.length <= 0" class="noDataMsg">
  <p style="border: 1px solid;" class="padding-b47">No Record Found.</p>
</div>

<div class="tileView" style=" overflow-y: auto; overflow-x: hidden; padding: 0 20px;">
  <div class="row gridSection" *ngFor="let parent of tileViewDataSource; let parentIndex = index">
    <div class="col-12 header-section">
      <h4>{{parent.manufacturer}}</h4>
    </div>
    <div class="col-12 p-0 m-0 tileSection" >
      <div class="row m-0">
        <div class=" p-0" style="width: 25%;" *ngFor="let child1 of parent.programGroupBy; let childIndex = index">
          <div class="card-layout">
            <h4 class="text-overflow">{{child1.program}}</h4>
            <p class="text-overflow">{{child1.notes}}</p>
            <hr />
            <div class="row px-1 pb-2 mr-0">
              <div class="col-8">
                <div class="row">
                  <div class="col-5 pr-0">
                    Order Period
                  </div>
                  <div class="col-7">
                    {{child1.orderPeriodStart | date:'MM/dd/yyyy'}} to {{child1.orderPeriodEnd | date:'MM/dd/yyyy'}}
                  </div>
                </div>
              </div>
              <div class="col-4">
                <div class="row">
                  <div class="col-8">
                    Incentive
                  </div>
                  <div class="col-4 pl-0">
                    {{child1.incentive}}
                  </div>
                </div>
              </div>
              <div class="col-8">
                <div class="row">
                  <div class="col-5 pr-0">
                    Ship Period
                  </div>
                  <div class="col-7">
                    {{child1.shipPeriodStart | date:'MM/dd/yyyy'}} to {{child1.shipPeriodEnd | date:'MM/dd/yyyy'}}
                  </div>
                </div>
              </div>
            </div>
            <div class="row bottom-row">
              <div class="col-4 pr-0 pl-1">
                PRODUCTS <span class="total-count">{{child1.mpItems.length}}</span>
              </div>
              <div class="col-7 pr-0" *ngIf="child1.mediaObjectId && child1.mediaObjectId != 0 ">
                <span>PROGRAM DETAILS </span><span (click)="downloadFile(child1.mediaObjectId)" class="details"><i  class="far fa-file-pdf"></i></span>
              </div>
              <div class="col-7 pr-0" *ngIf="child1.mediaObjectId == null  ||  child1.mediaObjectId == 0 ">
                
              </div>
              <div class="col-1 pr-2 pl-1 d-flex justify-content-end" style="cursor: pointer;" (click)="toggleDivVisibility(parentIndex, childIndex)">
                <div class="arrow" [ngClass]="(isDivVisible[parentIndex] && isDivVisible[parentIndex][childIndex]) ? 'up':'down'"></div>
              </div>
            </div>
            <div class="row my-1 productsToggleSection" *ngIf="isDivVisible[parentIndex] && isDivVisible[parentIndex][childIndex]">
              <div class="col-12 d-flex justify-content-between">
                <p>PRODUCTS</p>
                <div class="arrow" [ngClass]="(isDivVisible[parentIndex] && isDivVisible[parentIndex][childIndex]) ? 'up':'down'" style="cursor: pointer;" (click)="toggleDivVisibility(parentIndex, childIndex)"></div>
              </div>
              <div class="d-flex align-items-center" style="width: 100%">
                <div style="width: 3%;">
                  <i *ngIf="hasPreviousItems(parentIndex, childIndex)" class="fas fa-sort-down arrowLeft" style="cursor: pointer;" (click)="loadPreviousItems(parentIndex, childIndex)"></i>

                </div>
                <div class="row " style="width: 94%; margin: auto;">

                  <div class="pb-2 mr-2" style="width: 24%;" *ngFor="let child2 of getVisibleItems(child1.mpItems, parentIndex, childIndex)">
                    <div class="yellowBg">
                      <i [ngClass]="child2.isFavoriteProduct ? 'fa fa-regular fa-star' : 'far fa-star'" style="cursor: pointer;margin-right:5px;" (click)="toggleFavoriteItem(child2.itemID)"></i><span [matTooltip]="child2.itemID" [matTooltipPosition]="'above'"> {{child2.productName}}</span> 
                    </div>
                  </div>
                </div>
                <div class="" style="width: 3%;">

                  <i *ngIf="hasMoreItems(child1.mpItems, parentIndex, childIndex)" class="fas fa-sort-down arrowRight" style="cursor: pointer;" (click)="loadMoreItems(parentIndex, childIndex)"></i>
                </div>
              </div>
              
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
